import { FC } from "react";
import { Modal } from "@monolith-forensics/monolith-ui";
import CreateEvidenceChildForm from "../Forms/CreateEvidenceChildForm";
import { FormSubmitResult, Evidence } from "../evidence.types";

interface CreateEvidenceChildModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: (result: FormSubmitResult) => void;
  onCancel: () => void;
  defaultInfo: Evidence; // Parent evidence info
}

const CreateEvidenceChildModal: FC<CreateEvidenceChildModalProps> = ({
  show,
  onClose,
  onSubmit,
  onCancel,
  defaultInfo,
}) => {
  const handleSubmit = (result: FormSubmitResult) => {
    onSubmit?.(result);
    onClose();
  };

  const handleCancel = () => {
    onCancel?.();
    onClose();
  };

  return (
    <>
      <Modal open={show} onClose={onClose}>
        <CreateEvidenceChildForm
          width={700}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          defaultInfo={defaultInfo}
        />
      </Modal>
    </>
  );
};

export default CreateEvidenceChildModal;
